import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Grid, List, ListItem, ListItemText, Typography, styled } from "@mui/material";
import image1 from "../../../../assets/lagooncleaning/lagoon1.jpeg";
import image2 from "../../../../assets/lagooncleaning/lagoon2.jpeg";
import image3 from "../../../../assets/lagooncleaning/lagoon3.jpeg";
import image4 from "../../../../assets/lagooncleaning/lagoon4.jpeg";
import FooterInnerPagee from "../../../../common/FooterInnerPagee";
import Header from "../../../../common/Header";
import { useNavigate } from "react-router-dom";

const ScrollContainer = styled("div")(({ theme }) => ({
  display: "flex",
  overflowX: "auto",
  overflowY: "hidden",
  scrollSnapType: "x mandatory",
  scrollBehavior: "smooth",
  height: "100%",
  width: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    height: "100%",
    width: "100%",
  },
}));

const ScrollItem = styled("div")({
  flex: "0 0 100%",
  scrollSnapAlign: "start",
  height: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
});

const ScrollImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
  margin: 0,
  padding: 0,
});

const DotsContainer = styled("div")({
  position: "absolute",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  zIndex: 10,
  pointerEvents: "auto",
});

const Dot = styled("div")(({ active }) => ({
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  cursor: "pointer",
  backgroundColor: active ? "#fff" : "rgba(255,255,255,0.5)",
  transition: "background-color 0.3s ease",
  "&:hover": {
    backgroundColor: "white",
    transform: "scale(1.2)",
  },
}));


const Lagoon = () => {

  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleDotClick = (index) => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollWidth = container.scrollWidth;
    const itemWidth = scrollWidth / images.length;
    container.scrollTo({ left: itemWidth * index, behavior: "smooth" });
    setCurrentIndex(index);
  };

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollLeft = container.scrollLeft;
    const itemWidth = container.offsetWidth;
    const index = Math.round(scrollLeft / itemWidth);
    setCurrentIndex(index);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const navigate = useNavigate();

  const images = [image2, image1, image3, image4];

  useEffect(() => {
    const container = scrollRef.current;
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      setCurrentIndex(nextIndex);
      container.scrollTo({
        left: container.clientWidth * nextIndex,
        behavior: "smooth",
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollWidth = container.scrollWidth;
      const itemWidth = scrollWidth / images.length;
      const newIndex = Math.round(container.scrollLeft / itemWidth);
      setCurrentIndex(newIndex);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      handleDotClick(nextIndex);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex]);


  return (
    <>
      <Grid container>
        <Header />

        {/* Hero Section */}
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            width: "100%",
            height: { xs: "50vh", md: "65vh" },
            position: "relative",
          }}
        >
          <ScrollContainer ref={scrollRef}>
            {images.map((img, index) => (
              <ScrollItem key={index}>
                <ScrollImage src={img} alt={`Banner ${index + 1}`} />
              </ScrollItem>
            ))}
          </ScrollContainer>

          <DotsContainer>
            {images.map((_, idx) => (
              <Dot
                key={idx}
                active={currentIndex === idx}
                onClick={() => handleDotClick(idx)}
              />
            ))}
          </DotsContainer>
        </Grid>
        {/* Content Section Below */}

        <Grid item xs={12} md={12}>
          <Grid
            sx={{
              color: "#7f6b56",
              fontFamily: "Inter, sans-serif",
              px: { xs: 2, sm: 3 }, // less padding on xs
              py: { xs: 4, sm: 6 },
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              maxWidth={{ xs: "100%", sm: "md" }}
              width="100%"
              textAlign="center"
              sx={{
                border: '1px solid #7f6b56',
                p: { xs: 2, sm: 3 },
                borderRadius: 3,
                boxSizing: "border-box",
              }}
            >
              <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontSize: { xs: "1.6rem", sm: "2.125rem" }, // responsive font size
                  lineHeight: 1.2,
                }}
              >
                Lagoon Cleaning Drive at Androth Island: A Community-Led Conservation Effort
              </Typography>
              <Divider sx={{ bgcolor: '#7f6b56', mb: { xs: 2, sm: 3 } }} />

              <Typography
                variant="h5"
                fontWeight={600}
                gutterBottom
                sx={{
                  mt: { xs: 2, sm: 3 },
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1.25rem", sm: "1.375rem" },
                }}
              >
                Introduction
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 1,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                On January 17, 2025, Androth Island hosted a crucial environmental initiative organized by the Research & Environmental Education Foundation (REEF). The drive aimed to clean the lagoon and seashore of the island, focusing on preserving the ocean and raising awareness about pollution. The event brought together local fishermen, students, self-help groups, and other community members, all working together to help create a cleaner, healthier marine environment. During the drive, 4.5 tons of waste were collected, showcasing the power of community action in addressing environmental challenges.
              </Typography>

              {/* Event Overview */}
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: { xs: 3, sm: 4 }, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1.25rem", sm: "1.375rem" } }}>
                Event Overview
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ mt: 1, lineHeight: 1.6, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500 }}>
                The cleaning event began with a welcome address from Muhammed Nowshad B, the Chairman of REEF, who explained the importance of protecting marine ecosystems. He also highlighted the theme of the event, "Save the Ocean," which aimed to raise awareness about ocean pollution.
              </Typography>

              <Typography variant="body1" gutterBottom sx={{ mt: 2, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500 }}>
                Various community groups participated in the drive:
              </Typography>
              <Box sx={{ fontFamily: "Montserrat, sans-serif", mb: 2 }}>
                <List sx={{ paddingLeft: "1.2em" }}>
                  {[
                    { title: "Fishermen:", desc: "Local fishermen, whose livelihoods depend on the ocean, played a crucial role in the cleanup. Their participation reflected the direct impact pollution has on marine life and local industries." },
                    { title: "Club Members:", desc: "Local clubs and organizations provided additional support in terms of manpower and logistics." },
                    { title: "Students:", desc: "Students from the Government College of Arts and Science helped by participating in the cleaning efforts and spreading awareness on plastic waste." },
                    { title: "Women Self-Help Groups:", desc: "Women from local self-help groups not only participated in the cleanup but also promoted environmental responsibility within their communities." }
                  ].map(({ title, desc }) => (
                    <ListItem disableGutters key={title}>
                      <ListItemText
                        primary={
                          <Typography variant="body1" sx={{ fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500, lineHeight: 1.6, fontFamily: "Montserrat, sans-serif" }}>
                            <strong>{title}</strong> {desc}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>

              {/* Activities and Achievements */}
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: { xs: 3, sm: 4 }, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1.25rem", sm: "1.375rem" } }}>
                Activities and Achievements
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ mt: 1, lineHeight: 1.6, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500 }}>
                The main goal of the event was to clean the lagoon and seashore of Androth Island. The waste collected was mostly plastic items, discarded fishing nets, bottles, and other debris that threaten marine life.
              </Typography>
              <Box sx={{ fontFamily: "Montserrat, sans-serif", mb: 2 }}>
                <List sx={{ listStyleType: 'disc', paddingLeft: '1.2em' }}>
                  {[
                    { title: "Waste Collection:", desc: "Plastics are harmful to marine animals, as they can be ingested or cause entanglement. The drive focused on removing plastics and other harmful waste." },
                    { title: "Ghost Nets:", desc: 'Abandoned fishing nets, also known as "ghost nets," were also collected. These nets continue to trap marine life long after they have been discarded, causing serious harm to marine biodiversity.' },
                    { title: "Ecosystem Restoration:", desc: "By removing pollutants, the participants helped improve the health of the local ecosystem, including coral reefs and fish species that depend on a clean environment." }
                  ].map(({ title, desc }) => (
                    <ListItem sx={{ display: 'list-item', fontWeight: 'bold' }} disableGutters key={title}>
                      <ListItemText
                        primary={
                          <Typography variant="body1" sx={{ fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500, fontFamily: "Montserrat, sans-serif", lineHeight: 1.6 }}>
                            <strong>{title}</strong> {desc}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>

              {/* Importance of Collective Action */}
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: { xs: 3, sm: 4 }, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1.25rem", sm: "1.375rem" } }}>
                Importance of Collective Action
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ mt: 1, lineHeight: 1.6, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500 }}>
                The success of the lagoon cleaning drive demonstrated the importance of working together to protect the environment. The diverse participation of community members, from fishermen to students, highlights how collective action can make a big difference in tackling environmental issues. As Muhammed Nowshad B mentioned, such efforts are essential for promoting sustainable practices and ensuring the long-term health of marine ecosystems.
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ mt: 2, lineHeight: 1.6, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500 }}>
                The event also highlighted the need for regular cleaning initiatives to prevent waste buildup in the future. A single cleaning event is not enough to maintain the cleanliness of the ocean, and it is important for these initiatives to be ongoing.
              </Typography>

              {/* Stakeholder Perspectives */}
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: { xs: 3, sm: 4 }, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1.25rem", sm: "1.375rem" } }}>
                Stakeholder Perspectives
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ mt: 1, lineHeight: 1.6, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500 }}>
                Local stakeholders, especially fishermen, expressed their support for the event. They are directly impacted by ocean pollution and voiced concerns about the negative effects on their livelihoods. Many participants emphasized the importance of continuing such efforts and raising awareness about the dangers of plastic pollution.
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ mt: 2, lineHeight: 1.6, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500 }}>
                Community leaders also saw the event as a chance to educate the public about sustainable fishing practices and proper waste management. Discussions during the event underscored the need for better environmental policies at both local and national levels to protect the ocean and its resources.
              </Typography>

              {/* Conclusion */}
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: { xs: 3, sm: 4 }, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1.25rem", sm: "1.375rem" } }}>
                Conclusion
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ mt: 1, lineHeight: 1.6, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500 }}>
                The lagoon cleaning drive at Androth Island was a successful event, both in terms of the amount of waste collected and the message it sent about the importance of protecting marine ecosystems. The event highlighted the power of community involvement in environmental conservation. As global environmental challenges increase, it is essential that such efforts continue and become a regular part of local communities’ commitment to safeguarding the ocean.
              </Typography>

              {/* Recommendations */}
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: { xs: 3, sm: 4 }, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1.25rem", sm: "1.375rem" } }}>
                Recommendations
              </Typography>
              <Box sx={{ fontFamily: "Montserrat, sans-serif", mb: 2 }}>
                <List sx={{ listStyleType: 'decimal', paddingLeft: '1.2em' }}>
                  {[
                    { title: "Ongoing Engagement:", desc: "Regular lagoon and beach cleaning drives should continue, involving diverse community members." },
                    { title: "Education Programs:", desc: "Awareness campaigns about the impact of plastic pollution and sustainable fishing should be promoted." },
                    { title: "Policy Support:", desc: "Local authorities should develop policies supporting marine conservation and waste management." },
                    { title: "Infrastructure Improvement:", desc: "Facilities for proper waste disposal should be improved on Androth Island to reduce littering." }
                  ].map(({ title, desc }) => (
                    <ListItem sx={{ display: 'list-item', fontWeight: 'bold' }} disableGutters key={title}>
                      <ListItemText
                        primary={
                          <Typography variant="body1" sx={{ fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500, fontFamily: "Montserrat, sans-serif", lineHeight: 1.6 }}>
                            <strong>{title}</strong> {desc}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
          </Grid>
        </Grid>


        <Box sx={{ maxWidth: 700, margin: "0 auto", pX: 3, pb: 2 }}>
          <Grid container spacing={5}>
            {/* First Image with Text */}
            {/* <Grid item xs={12} md={6}>
              <img
                src={image1}
                alt="Nature"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  //   borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mr: 1, cursor: "pointer" }}
                  onClick={() => navigate("/empowering-communities")}
                >
                  Empowering Communities, Protecting Oceans
                </Typography>
              </Box>
            </Grid> */}

            {/* Second Image with Text */}
            {/* <Grid item xs={12} md={6}>
              <img
                src={image2}
                alt="Nature"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  //   borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mr: 1, cursor: "pointer" }}
                  onClick={() => navigate("/restoring-hope")}
                >
                  Restoring Hope, One Coral at a Time
                </Typography>
              </Box>
            </Grid> */}
          </Grid>
        </Box>
      </Grid>
      <FooterInnerPagee />
    </>
  );
};

export default Lagoon;